import { useEffect, useState } from "react";
import { STATUS_TIMER } from "../../services/utils/Constants";
import { useInterval } from "../../hooks/useInterval";
import { cryptoUtil } from "../../services/utils/CryptoUtil";

export const Timer = ({ onFinish, initialSeconds, setCurrentTimeCounter, isReset = false }) => {
    const [secondsRemaining, setSecondsRemaining] = useState(initialSeconds);

    const [status, setStatus] = useState(STATUS_TIMER.STOPPED);
    const secondsToDisplay = secondsRemaining % 60;
    const minutesRemaining = (secondsRemaining - secondsToDisplay) / 60;
    const minutesToDisplay = minutesRemaining % 60;

    if (setCurrentTimeCounter) {
        setCurrentTimeCounter(secondsRemaining);
    }

    useEffect(() => {
        setStatus(STATUS_TIMER.STARTED);
        setSecondsRemaining(initialSeconds);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isReset]);

    useInterval(
        () => {
            if (secondsRemaining >= 1) {
                setSecondsRemaining(secondsRemaining - 1);
            } else {
                onFinish();
                setStatus(STATUS_TIMER.STOPPED);
            }
        },
        status === STATUS_TIMER.STARTED ? 1000 : null,
        // passing null stops the interval
    );

    return (
        <span style={{ fontWeight: "600" }}>
            {cryptoUtil.twoDigits(minutesToDisplay)}:{cryptoUtil.twoDigits(secondsToDisplay)}
        </span>
    );
};
